import { Input } from '@lib/components'
import type React from 'react'
import { useRef } from 'react'

import css from './styles.module.css'

const CODE_INPUT_LENGTH = 6

type Props = {
  code: string
  error: boolean
  disabled: boolean
  onChange: (code: string) => void
}

export const CodeInput = ({ code, error, disabled, onChange }: Props) => {
  const inputs = useRef<(HTMLInputElement | null)[]>([])

  const focusInput = (index: number) => {
    inputs.current[index]?.focus()
  }

  const handleChange = (value: string, index: number) => {
    if (/^[0-9]?$/.test(value)) {
      const newCode =
        code.substring(0, index) + value + code.substring(index + 1)
      onChange(newCode)

      if (value && index < CODE_INPUT_LENGTH - 1) {
        focusInput(index + 1)
      }
    }
  }

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      focusInput(index - 1)
    }
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    const paste = e.clipboardData.getData('text').replace(/\D/g, '')
    const newCode = paste.slice(0, CODE_INPUT_LENGTH)
    const padded = newCode.padEnd(CODE_INPUT_LENGTH, '')
    onChange(padded)

    setTimeout(() => {
      const nextIndex = Math.min(newCode.length, CODE_INPUT_LENGTH - 1)
      focusInput(nextIndex)
    }, 0)
  }

  return (
    <div>
      <div className={css.code_inputGroup}>
        {Array.from({ length: CODE_INPUT_LENGTH }).map((_, index) => (
          <div className={css.code_inputWrap} key={index}>
            <Input
              type="normal"
              errorHighlight={error}
              disabled={disabled}
              // @ts-expect-error
              ref={(el) => (inputs.current[index] = el)}
              initialValue={code[index] || ''}
              onFocus={(e) => e.target.select()}
              onChange={(value) => handleChange(value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              placeholder="0"
              classnames={{ input: css.code_input }}
              maxLength={1}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
